import { useChatMessageContext } from 'features/chat/context/chatMessage';

import { ChatMessageAudioPlayer } from './ChatMessageAudioPlayer';

type ChatMessageAudioAttachmentProps = {
  url: string;
  attachmentKey?: string;
  duration: number; // in sec
};

export const ChatMessageAudioAttachment = ({
  url,
  attachmentKey,
  duration,
}: ChatMessageAudioAttachmentProps) => {
  const isLoading = !attachmentKey;
  const { isIncoming } = useChatMessageContext();

  return (
    <ChatMessageAudioPlayer src={url} duration={duration}>
      {({ isPlaying, togglePlay, audioDuration }) => {
        return (
          <>
            {isLoading && <ChatMessageAudioPlayer.Loader />}
            {!isLoading && (
              <ChatMessageAudioPlayer.PlayPauseButton
                isPlaying={isPlaying}
                togglePlay={togglePlay}
                color={isIncoming ? 'var(--white)' : 'var(--bgCompAccent)'}
                bgColor={isIncoming ? 'black' : 'white'}
              />
            )}
            <ChatMessageAudioPlayer.Wave
              fill={isIncoming ? 'var(--black)' : 'var(--white)'}
            />
            <ChatMessageAudioPlayer.AudioDuration
              duration={audioDuration}
              color={isIncoming ? 'whiteTotal' : 'blue'}
              bgColor={isIncoming ? 'black' : 'whiteTotal'}
            />
          </>
        );
      }}
    </ChatMessageAudioPlayer>
  );
};
